import { useContext, useEffect } from 'react'
import { fetchTourDealDetails } from 'actions/tour/TourV2Actions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import getObjectKey from 'lib/object/getObjectKey'
import GeoContext from 'contexts/geoContext'

type ReturnType = [
  App.Tours.TourDealDetails | undefined,
  boolean,
]

export function useTourDealDetails(slug: string | undefined, filters: App.Tours.TourDealFiltersApplied, sortParams: App.Tours.TourDealSortState): ReturnType {
  const uniqueKey = getObjectKey({ ...filters, ...sortParams, slug })
  const dispatch = useAppDispatch()
  const deal = useAppSelector((state) => state.tour.tourDealsDetails[uniqueKey])
  const fetchingDeal = useAppSelector((state) => state.tour.fetchingTourDealDetailsBySlug[uniqueKey])
  const { currentRegionCode } = useContext(GeoContext)

  useEffect(() => {
    if (slug) {
      dispatch(fetchTourDealDetails(slug, uniqueKey, filters, sortParams, currentRegionCode.toUpperCase()))
    }
  }, [slug, filters, sortParams, uniqueKey, dispatch, currentRegionCode])

  return [
    deal,
    fetchingDeal,
  ]
}
